export interface IAppError {
  type?: string;
  message?: string;
  details?: string[];
}

type ErrorWithStack = ErrorConstructor & {
  captureStackTrace?: (targetObject: object, constructorOpt?: Function) => void;
};


export class AppError extends Error {
  public type: string;
  public message: string;
  public details: string[];
  public isAppError: boolean;

  public constructor(settings: IAppError = {}) {
    super(settings.message || 'An error occurred.');

    this.name = 'AppError';
    this.type = settings.type || 'Application';
    this.message = settings.message || 'An error occurred.';
    this.details = settings.details || [];
    this.isAppError = true;

    // Solution type-safe avec vérification
    const ErrorWithStack = Error as ErrorWithStack;
    if (typeof ErrorWithStack.captureStackTrace === 'function') {
      ErrorWithStack.captureStackTrace(this, AppError);
    } else {
      // Fallback pour les environnements sans captureStackTrace
      this.stack = (new Error()).stack;
    }
  }
}